import moment from 'moment';
import 'moment/locale/es';

export const adaptProveedor = (proveedorData) => {
    
    const concacList = (bultos, kilos, kms) => {

        const listaBultos = bultos.map((bulto) => {
            let obj = {
                id: bulto?.idProveedorMetodoCobroBulto + 1000,
                modalidad: 'Bulto',
                fechaDesde: moment(bulto?.fechaDesde).format("yyyy-MM-DD"),
                fechaHasta: (bulto?.fechaHasta) ? moment(bulto?.fechaHasta).format("yyyy-MM-DD") : null,
                cantidad: bulto?.cantidad,
                pesoExcedido: '',
                pesoLimite: '',
                valor: bulto?.precio,
            }
            return obj;
        });

        const listaKilos = kilos.map((kilo) => {
            let obj = {
                id: kilo?.idProveedorMetodoCobroKilo + 2000,
                modalidad: 'Kilo',
                fechaDesde: moment(kilo?.fechaDesde).format("yyyy-MM-DD"),
                fechaHasta: (kilo?.fechaHasta) ? moment(kilo?.fechaHasta).format("yyyy-MM-DD") : null,
                cantidad: '',
                pesoExcedido: kilo?.valorExcedido,
                pesoLimite: kilo?.pesoLimite,
                valor: kilo?.valor,
            }
            return obj;
        });

        const listaKms = kms.map((km) => {
            let obj = {
                id: km?.idProveedorMetodoCobroKM + 3000,
                modalidad: 'Km',
                fechaDesde: moment(km?.fechaDesde).format("yyyy-MM-DD"),
                fechaHasta: (km?.fechaHasta) ? moment(km?.fechaHasta).format("yyyy-MM-DD") : null,
                cantidad: '',
                pesoExcedido: '',
                pesoLimite: '',
                valor: km?.valor,
            }
            return obj;
        });

        return listaBultos.concat(listaKilos).concat(listaKms);
    }

    return {
        idProveedorDistribuidor: proveedorData?.idProveedorDistribuidor,
        codigoSAP: proveedorData?.codigoSAP,
        razonSocial: proveedorData?.razonSocial,
        contacto: proveedorData?.contacto,
        telefonoAdicional: proveedorData?.telefonoAdicional,
        email: proveedorData?.email,
        activo: proveedorData?.activo,
        observacion: proveedorData?.observacion,
        idDeposito: proveedorData?.idDeposito,
        modalidadBultos: proveedorData?.modalidadBultos,
        modalidadKms: proveedorData?.modalidadKMs,
        modalidadKilos: proveedorData?.modalidadKilos,
        listModalidades: {
            bultos: proveedorData?.modalidadBultos.map((bulto) => {
                let obj = {
                    id: bulto?.idProveedorMetodoCobroBulto + 1000,
                    modalidad: 'Bulto',
                    fechaDesde: moment(bulto?.fechaDesde).format("yyyy-MM-DD"),
                    fechaHasta: (bulto?.fechaHasta) ? moment(bulto?.fechaHasta).format("yyyy-MM-DD") : null,
                    cantidad: bulto?.cantidad,
                    pesoExcedido: '',
                    pesoLimite: '',
                    valor: bulto?.precio,
                }
                return obj;
            }),
            kilos: proveedorData?.modalidadKilos.map((kilo) => {
                let obj = {
                    id: kilo?.idProveedorMetodoCobroKilo + 2000,
                    modalidad: 'Kilo',
                    fechaDesde: moment(kilo?.fechaDesde).format("yyyy-MM-DD"),
                    fechaHasta: (kilo?.fechaHasta) ? moment(kilo?.fechaHasta).format("yyyy-MM-DD") : null,
                    cantidad: '',
                    pesoExcedido: kilo?.valorExcedido,
                    pesoLimite: kilo?.pesoLimite,
                    valor: kilo?.valor,
                }
                return obj;
            }),
            kms: proveedorData?.modalidadKMs.map((km) => {
                let obj = {
                    id: km?.idProveedorMetodoCobroKM + 3000,
                    modalidad: 'Km',
                    fechaDesde: moment(km?.fechaDesde).format("yyyy-MM-DD"),
                    fechaHasta: (km?.fechaHasta) ? moment(km?.fechaHasta).format("yyyy-MM-DD") : null,
                    cantidad: '',
                    pesoExcedido: '',
                    pesoLimite: '',
                    valor: km?.valor,
                }
                return obj;
            })
        },
        checkSelected: {
            km: proveedorData?.modalidadKMs.length > 0,
            peso: proveedorData?.modalidadKilos.length > 0,
            bulto: proveedorData?.modalidadBultos.length > 0
        },
        rowsModalidades: concacList(proveedorData?.modalidadBultos, proveedorData?.modalidadKilos, proveedorData?.modalidadKMs)
    }
}

export const adaptProveedorArray = (
    proveedoresData
) => {
    return adaptProveedor(proveedoresData?.proveedorDistribuidorById)
}


